export const microfrontendOriginDefinitions = {
  certificados: {
    domain: 'certificado-cobertura.artprovincia.ar',
  },
  nomina: {
    domain: 'nomina.artprovincia.ar',
  },
  informes: {
    domain: 'informes.artprovincia.ar',
  },
  credenciales: {
    domain: 'credenciales.artprovincia.ar',
  },
  'administracion-usuario': {
    // Producción usa el dominio sin prefijo; dev/test/beta agregan el ambiente.
    domain: 'administracion-usuario.artprovincia.ar',
  },
  'informe-cancerigeno': {
    domain: 'informecancerigeno.artprovincia.ar',
  },
  rar: {
    domain: 'rar.artprovincia.ar',
  },
  ige: {
    domain: 'ige.artprovincia.ar',
  },
}

const getDefinition = (microfrontend) => {
  const definition = microfrontendOriginDefinitions[microfrontend]
  if (!definition) throw new Error(`Microfrontend desconocido: ${microfrontend}`)
  return definition
}

const normalizeOrigin = (rawOrigin, source) => {
  if (rawOrigin == null || rawOrigin === '') return null
  if (typeof rawOrigin !== 'string') throw new Error(`${source} debe ser una URL`)
  const origin = new URL(rawOrigin.trim()).origin
  if (!origin.startsWith('http://') && !origin.startsWith('https://')) {
    throw new Error(`${source} debe usar http o https`)
  }
  return origin
}

export function parseMicrofrontendOrigins(rawOrigins) {
  if (!rawOrigins?.trim()) return {}

  try {
    const origins = JSON.parse(rawOrigins)
    if (!origins || Array.isArray(origins) || typeof origins !== 'object') throw new Error()
    return origins
  } catch {
    throw new Error('VITE_MFE_ORIGINS debe ser un objeto JSON válido')
  }
}

export function resolveMicrofrontendOrigin(microfrontend, env = {}) {
  const { domain } = getDefinition(microfrontend)
  const localOrigins = parseMicrofrontendOrigins(env.VITE_MFE_ORIGINS)
  const explicitOrigin = normalizeOrigin(localOrigins[microfrontend], `VITE_MFE_ORIGINS.${microfrontend}`)
  if (explicitOrigin) return explicitOrigin

  const environmentPrefix = env.VITE_ENV_URL_PREFIX?.trim().toLowerCase()
  if (!environmentPrefix) {
    throw new Error(
      `Falta VITE_MFE_ORIGINS.${microfrontend} para local o VITE_ENV_URL_PREFIX para un ambiente desplegado`
    )
  }
  const prefix = environmentPrefix === 'prod' ? '' : `${environmentPrefix}-`
  return `https://${prefix}${domain}`
}

export function isMicrofrontendOrigin(microfrontend, origin, configuredOrigin) {
  const { domain } = getDefinition(microfrontend)
  const url = new URL(origin)
  if (configuredOrigin && url.origin === normalizeOrigin(configuredOrigin, `origen configurado de ${microfrontend}`))
    return true
  return url.hostname === domain || url.hostname.endsWith(`-${domain}`)
}
